import { render, staticRenderFns } from "./SurveyStructure.vue?vue&type=template&id=b21935ce&scoped=true&"
import script from "./SurveyStructure.vue?vue&type=script&lang=js&"
export * from "./SurveyStructure.vue?vue&type=script&lang=js&"
import style0 from "./SurveyStructure.vue?vue&type=style&index=0&id=b21935ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21935ce",
  null
  
)

export default component.exports